<template>
  <div class="relative p-4 -mx-[4vw] lg:mx-0 lg:rounded lg:overflow-hidden">
    <div class="min-h-[32rem] md:min-h-[24rem] flex items-center justify-center">
      <div class="grid gap-8 md:gap-10 text-center relative z-20">
        <div class="w-full text-white grid gap-1">
          <!-- <div class="hero__label" v-html="$t('city.start.hero.label')" /> -->
          <h1 class="hero__heading" v-html="fat.city?.name" />
          <p class="hero__leading" v-html="$t('city.start.hero.tagline')" />
        </div>
        <!-- <button @click="goToFat" class="grid gap-3 mx-auto p-3 rounded bg-black/25">
          <div class="flex items-center gap-4 xl:gap-6 bg-white rounded p-3">
            <div class="flex items-center gap-2">
              <AtomIcon name="user-group" class="text-coral min-h-5" />
              <div class="text-sm font-medium">{{ fat.meal?.name ? $t('shared.amount', fat.amount) : $t('shared.amountAbbr', fat.amount)  }}</div>
            </div>
            <div class="flex items-center gap-2">
              <AtomIcon name="calendar" class="text-coral min-h-5 -mt-px" />
              <div class="text-sm font-medium">{{ useUcFirst(dateText) }}</div>
            </div>
            <div class="flex items-center gap-2">
              <AtomIcon name="clock" class="text-coral min-h-5" />
              <div class="text-sm  font-medium">{{ fat.meal?.name || fat?.timeRange }}</div>
            </div>
          </div>
          <div class="button-coral w-full">{{ $t('shared.searchTable') }}</div>
        </button> -->
        <button @click="goToFat" class="button-coral w-48 mx-auto">
          {{ $t('shared.searchFreeTable') }}
        </button>
      </div>
      <div class="absolute top-0 left-0 z-10 w-full h-full">
        <div class="absolute z-10 top-0 left-0 w-full h-full bg-[#545A5A]/50" />
        <div class="sm:hidden">
          <img class="absolute top-0 left-0 w-full h-full object-cover" src="~/assets/images/start-hero-mobile.jpg" />
        </div>
        <div class="max-sm:hidden">
          <img class="absolute top-0 left-0 w-full h-full object-cover" src="~/assets/images/start-hero-desktop.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()
const fat = useFatStore()
const router = useRouter()

// Create date text 
const dateText = computed(() => {
  if (toDayjs(fat.date).isToday()) {
    return t('shared.today')
  }
  if (toDayjs(fat.date).isTomorrow()) {
    return t('shared.tomorrow')
  }

  return toDayjs(fat.date).format('ddd D/M')
})

// Push FAT route instead of using indexable link
const goToFat = () => {
  router.push({ name: 'fat' })
}
</script>

<style lang="scss" scoped>
.hero {
  &__label {
    @apply font-bold uppercase tracking-[0.25em];
  }

  &__heading {
    @apply font-heading font-bold;
    @apply text-6xl lg:text-7xl xl:text-8xl;
  }

  &__leading {
    @apply font-heading font-medium;
    @apply text-xl lg:text-2xl xl:text-3xl;
  }
}
</style>